export function syncDocumentLang(locale) {
  const lang = locale === 'en' ? 'en' : 'de'
  document.documentElement.lang = lang
}
